import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { RepromptIcon } from '@utilities';
import { reportStatus } from '@helpers';

import { getReportStatusMessage } from './utilities/helpers';

import styles from './_index.module.scss';

const ReportStatus = ({ onComplete, report, showCompleteMessage, showTruncatedMessage }) => {
  const reports = useSelector((state) => state?.websocket?.reports);

  const completedStatus = reportStatus.COMPLETED;

  const websocketReport = reports?.find(
    (websocketReport) => Number(websocketReport?.id) === Number(report?.id)
  );
  const data =
    (websocketReport?.status || 0) > (report?.status || 0) ||
    ((websocketReport?.status || 0) === (report?.status || 0) &&
      (websocketReport?.numberCompleteTabs || 0) >= (report?.numberCompleteTabs || 0))
      ? websocketReport
      : report;

  useEffect(() => {
    if (data?.status >= completedStatus) onComplete();
  }, [data?.status, onComplete]);

  if (data?.status < completedStatus) {
    return (
      <div className={styles['report-status']}>
        <RepromptIcon className={styles['report-status-loading-icon']} />
        {getReportStatusMessage({ data, showTruncatedMessage })}
        ...
      </div>
    );
  }

  if (showCompleteMessage) {
    return getReportStatusMessage({ data, showTruncatedMessage });
  }

  return null;
};

ReportStatus.defaultProps = {
  onComplete: () => {},
};

ReportStatus.propTypes = {
  onComplete: PropTypes.func,
  report: PropTypes.object,
  showCompleteMessage: PropTypes.bool,
  showTruncatedMessage: PropTypes.bool,
};

export default ReportStatus;
